let deferredPrompt: any = null;
let installPromptShown = false;

export function initPWAInstall() {
  // Check if running in standalone mode (already installed)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return;
  }

  // Listen for beforeinstallprompt event
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
  });

  // Show install prompt after 1 minute
  setTimeout(() => {
    if (deferredPrompt && !installPromptShown) {
      showInstallPrompt();
    }
  }, 60000); // 1 minute
}

export function showInstallPrompt() {
  if (!deferredPrompt || installPromptShown) return;
  
  deferredPrompt.prompt();
  
  deferredPrompt.userChoice.then((choiceResult: any) => {
    if (choiceResult.outcome === 'accepted') {
      console.log('User accepted the install prompt');
    } else {
      console.log('User dismissed the install prompt');
    }
    deferredPrompt = null;
    installPromptShown = true;
  });
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      for(let registration of registrations) {
        registration.unregister()
          .then(function() {
            console.log('ServiceWorker unregistered successfully');
          })
          .catch(function(error) {
            console.log('ServiceWorker unregistration failed: ', error);
          });
      }
    });
  }
}
